import { useLessonPlayer } from '../../hooks/useLessonPlayer.js'
import { FRAMES } from '../../model/frames.js'
import SchematicLayout from './SchematicLayout.jsx'

export default function SchematicIndScreen({ frames = FRAMES } = {}) {
  const player = useLessonPlayer(frames)
  return <SchematicLayout theme="industry" {...player} />
}
